import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './SuggestionsAndSystemEnhancement.html';
import { SuggestionsAndSystemEnhancementListItem } from './SuggestionsAndSystemEnhancementModel';
import { Toaster } from '../../Services/toast';
import SuggestionsAndSystemEnhancementService from './SuggestionsAndSystemEnhancementService';
import { SuggestionServiceType } from './SuggestionServiceType';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        SuggestionsAndSystemEnhancementService,
    ],
})

export default class SuggestionsAndSystemEnhancement extends Vue {
    @Inject(SuggestionsAndSystemEnhancementService) public SuggestionsAndSystemEnhancementService!: SuggestionsAndSystemEnhancementService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    public headers: any = [
        { text: this.$t('shared.providerName'), value: 'providerName', align: 'center', sortable: false },
        { text: this.$t('shared.serviceName'), value: 'service', align: 'center', sortable: false },
        { text: this.$t('shared.suggestionTitle'), value: 'title', align: 'center', sortable: false },
        { text: this.$t('shared.addedDate'), value: 'createdDate', align: 'center', sortable: false },
        { text: this.$t('shared.details'), sortable: false, value: 'id', align: 'center', width: '75' },
    ];

    public suggestions: SuggestionsAndSystemEnhancementListItem[] = [];
    public suggestionsCount: number = 0;
    public filterModel: any = {
        providerName: '',
        service: null,
    };

    public services: { name: string; id: number }[] = [
        { name: 'New Service', id: SuggestionServiceType.NewService },
        { name: 'Sender Name Registration', id: SuggestionServiceType.SenderNameRegistration },
        { name: 'Contract Request', id: SuggestionServiceType.ContractRequest },
        { name: 'Renewal Request', id: SuggestionServiceType.RenewalRequest },
        { name: 'Connectivity Request', id: SuggestionServiceType.ConnectivityRequest },
        { name: 'Payment', id: SuggestionServiceType.Payment },
    ];

    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        await this.search();
    }



    public async search() {
        const model = {
            providerName: this.filterModel.providerName || '',
            service: this.filterModel.service == null ? '' : this.filterModel.service.toString(),
            pageIndex: '0',
            pagesize: '10',
        };

        const response = await this.SuggestionsAndSystemEnhancementService.getSuggestions(model);

        if (response !== false) {
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            }

            this.suggestions = response.result;
            this.suggestionsCount = response.totalCount;
        }
    }

    public async updatePaginate(val: any) {
        const model = {
            providerName: this.filterModel.providerName || '',
            service: this.filterModel.service !== null ? this.filterModel.service.toString() : '',
            pageIndex: (val.page - 1).toString(),
            pagesize: val.rowsPerPage.toString(),
        };

        const response = await this.SuggestionsAndSystemEnhancementService.getSuggestions(model);

        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }

        this.suggestions = response.result;
        this.suggestionsCount = response.totalCount;
    }


    public getServiceName(serviceId: number): string {
        const match = this.services.find(s => s.id === serviceId);
        return match ? match.name : '-';
    }
}
